
import { Component, Vue } from 'vue-property-decorator';
import { isMobile } from '@/utils/tool';

@Component
export default class DeviceLayout extends Vue {
  public isMobile = isMobile();
}
